import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "./queryKeys";
import {
  getLocationTypes,
  LocationType,
} from "~/lib/server-functions/get-location-types";

export const useLocationTypes = (ids?: number[] | string[]) => {
  // Check if the array contains numbers or strings
  const isNames = ids && ids.length > 0 && typeof ids[0] === "string";
  
  return useQuery<LocationType[]>({
    queryKey: [QUERY_KEYS.LOCATION_TYPES, ids],
    queryFn: async () => {
      if (isNames) {
        const locationTypes = await getLocationTypes({
          data: { names: ids as string[] },
        });
        return locationTypes;
      } else {
        const locationTypes = await getLocationTypes({
          data: ids ? { ids: ids as number[] } : undefined,
        });
        return locationTypes;
      }
    },
  });
};
